import { FC } from 'react'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { ContainedButton } from '../../../../../components/Button'
import { useSelector } from 'react-redux'
import { FormsSelector } from '../../../../../store/forms'
import { RootState } from '../../../../../store'

interface CompletedProps {
  resetUpload: () => void,
  imageFormId: string,
}

export const Completed:FC<CompletedProps> = ({resetUpload, imageFormId}) => {
  const theme= useTheme()
  const image = useSelector((state:RootState)=>FormsSelector.getFormValues(state, imageFormId))
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 500,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection:'column'
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{flexWrap:'wrap', maxWidth:'100%'}}>
        <CheckCircleIcon sx={{ fontSize: 28, color: theme.palette.success.main }} />
        <Typography variant="h6">Test strip uploaded successfully</Typography>
        {image && (<Box sx={{py:2}}>
          <img src={image.localUrl} width='100%' />
        </Box>)}
      </Stack>
      <ContainedButton onClick={resetUpload} sx={{alignSelf:'flex-end'}}>Reupload</ContainedButton>
    </Box>
  )
}